import TwinalyzeAnalytics from "./index.js";

window.twinalyze = TwinalyzeAnalytics;
window.TwinalyzeAnalytics = TwinalyzeAnalytics;